import React, { useEffect, useState } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import swal from "sweetalert"
import { axiosbaseurl } from "configure"
import LoadingButton from "components/Common/LoadingButton"
import { customStyles } from "helpers/select-styles"
import Select from "react-select"
import moment from "moment"
import secureLocalStorage from "react-secure-storage"

const AddReporteesManualLogs = ({
  show: controlledShow,
  setShow: controlledSetShow,
  onSuccess,
  hideTrigger = false,
}) => {
  const [internalShow, setInternalShow] = useState(false)
  const show = controlledShow !== undefined ? controlledShow : internalShow
  const setShow = controlledSetShow || setInternalShow
  const showTriggerButton =
    !hideTrigger && controlledShow === undefined && !controlledSetShow
  const [loading, setLoading] = useState(false)

  const [tasksOptions, settasksOptions] = useState([])
  const [worksTypeOptions, setworksTypeOptions] = useState([])
  const [clientOptions, setclientOptions] = useState([])
  const [servicesOptions, setservicesOptions] = useState([])

  const [employeeOptions, setEmployeeOptions] = useState([])

  const logTypeOptions = ["Scheduled", "Non-Scheduled"]

  const createEmptyEntry = () => ({
    key: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    logType: "Scheduled",
    employee: null,
    client: null,
    task: null,
    service: null,
    workType: null,
    startTime: "",
    endTime: "",
  })

  // fixed header fields
  const [logDate, setLogDate] = useState(moment().format("YYYY-MM-DD"))

  // repeatable entry rows below Type/Date
  const [entries, setEntries] = useState([createEmptyEntry()])

  // const [manualTitle, setManualTitle] = useState("")
  const [description, setDescription] = useState("")

  const updateEntry = (key, field, value) => {
    setEntries(prev =>
      prev.map(entry => {
        if (entry.key !== key) return entry
        // clear dependent fields
        if (field === "client")
          return {
            ...entry,
            client: value,
            task: null,
            service: null,
          }
        return { ...entry, [field]: value }
      })
    )
  }

  const addEntry = () => {
    setEntries(prev => [...prev, createEmptyEntry()])
  }

  const removeEntry = key => {
    setEntries(prev =>
      prev.length <= 1 ? prev : prev.filter(e => e.key !== key)
    )
  }

  const authUser = secureLocalStorage.getItem("authUser")

  // reset states
  useEffect(() => {
    if (!show) {
      setLogDate(moment().format("YYYY-MM-DD"))
      setEntries([createEmptyEntry()])
      setDescription("")
    }
  }, [show])

  // getting dropdown options common function
  async function getOptions(api) {
    try {
      const response = await axiosbaseurl.get(api)
      if (response.data.success) return response.data.data

      return false
    } catch (error) {
      console.log(error)
    }
  }

  // clients, tasks, worktypes
  // getting dropdown options
  useEffect(() => {
    if (show) {
      ;(async () => {
        try {
          let options = []

          options = await getOptions(
            `/employee-master/active/reportees/${authUser.employeeId}`
          )
          setEmployeeOptions(
            options
              ?.slice()
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(reportee => ({
                value: reportee.id,
                label: `${reportee.name} ${reportee.lastName}`,
              })) || []
          )

          options = await getOptions("/tasks/all/normal")
          settasksOptions(
            options
              ?.slice()
              .sort((a, b) => a.title.localeCompare(b.title))
              .map(task => ({
                value: task.id,
                label: `${task.title} - ${moment
                  .utc(task.startDate)
                  .format("DD-MM-YYYY")}`,
                clientId: task.clientId,
                serviceId: task.serviceNameId,
              })) || []
          )

          options = await getOptions("/work-type/active")
          setworksTypeOptions(
            options
              ?.slice()
              .sort((a, b) => a.workType.localeCompare(b.workType))
              .map(work => ({
                value: work.id,
                label: work.workType,
              })) || []
          )

          options = await getOptions("/client")
          setclientOptions(
            options
              ?.slice()
              .sort((a, b) => a.clientName.localeCompare(b.clientName))
              .map(client => ({
                value: client.id,
                label: `${client.clientCode} - ${client.clientName}`,
                clientTypeId: client.clientTypeId,
              })) || []
          )

          options = await getOptions("/service-master/active")
          setservicesOptions(
            options
              ?.filter(
                svc =>
                  svc.serviceCategory === "Non-Billiable and Non-scheduled" ||
                  svc.serviceCategory === "Billiable and Non-scheduled"
              )
              ?.slice()
              .sort((a, b) => a.serviceName.localeCompare(b.serviceName))
              .map(service => ({
                value: service.id,
                label: service.serviceName,
                clientTypeId: service.clientTypeId,
              })) || []
          )
        } catch (error) {
          console.log(error)
        }
      })()
    }
  }, [show])

  function calculateTimeDifference(startTime, endTime) {
    // Parse the start and end times as moment objects
    const start = moment(startTime, "HH:mm")
    const end = moment(endTime, "HH:mm")

    // If end time is earlier than start time, add a day to end time
    if (end.isBefore(start)) {
      end.add(1, "days")
    }

    // Calculate the difference in minutes
    const duration = moment.duration(end.diff(start))

    // Get total hours and minutes
    const hours = String(Math.floor(duration.asHours())).padStart(2, "0") // Ensure two digits
    const minutes = String(duration.minutes()).padStart(2, "0") // Ensure two digits

    return `${hours}:${minutes}`
  }

  const getFilteredServicesForEntry = entry => {
    if (entry?.logType !== "Non-Scheduled" || !entry?.client?.clientTypeId) {
      return servicesOptions
    }

    return servicesOptions.filter(
      svc =>
        svc.clientTypeId === entry.client.clientTypeId || svc.clientTypeId === 0
    )
  }

  const getEntryTotal = entry => {
    if (!entry?.startTime || !entry?.endTime) return "00:00"
    return calculateTimeDifference(entry.startTime, entry.endTime)
  }

  const getDayTotal = () => {
    let mins = 0
    entries.forEach(entry => {
      if (!entry?.startTime || !entry?.endTime) return
      const start = moment(entry.startTime, "HH:mm")
      const end = moment(entry.endTime, "HH:mm")
      if (end.isBefore(start)) end.add(1, "days")
      mins += Math.max(0, end.diff(start, "minutes"))
    })
    const hours = String(Math.floor(mins / 60)).padStart(2, "0")
    const minutes = String(mins % 60).padStart(2, "0")
    return `${hours}:${minutes}`
  }

  // only last 5 dates selectable (today + previous 4 days)
  const maxDate = moment().format("YYYY-MM-DD")
  const minDate = moment().subtract(4, "days").format("YYYY-MM-DD")

  // Handle form submission (single submit for all entries)
  const handleSubmit = async e => {
    e.preventDefault()

    if (!logDate || logDate < minDate || logDate > maxDate) {
      swal(
        "Validation Error",
        "Please select a date within the last 5 days.",
        "warning"
      )
      return
    }

    // Validate each entry based on log type
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i]
      const label = `Entry ${i + 1}`
      if (entry.logType === "Scheduled") {
        if (
          !entry.employee ||
          !entry.client ||
          !entry.workType ||
          !entry.task ||
          !entry.startTime ||
          !entry.endTime
        ) {
          swal(
            "Validation Error",
            `${label}: All fields marked with * are required for Scheduled logs!`,
            "warning"
          )
          return
        }
      } else {
        if (
          !entry.employee ||
          !entry.client ||
          !entry.workType ||
          !entry.service ||
          !entry.startTime ||
          !entry.endTime
        ) {
          swal(
            "Validation Error",
            `${label}: All fields marked with * are required for Non-Scheduled logs!`,
            "warning"
          )
          return
        }
      }

      if (getEntryTotal(entry) === "00:00") {
        swal(
          "Insufficient Total Time",
          `${label}: Minimum one minute expected`,
          "warning"
        )
        return
      }
    }

    try {
      setLoading(true)

      // build array of all entries and submit together
      const payload = entries.map(entry => ({
        ...(entry.task?.value ? { taskId: entry.task.value } : {}),
        workTypeId: entry.workType?.value,
        startTime: entry.startTime,
        endTime: entry.endTime,
        ...(entry.logType === "Non-Scheduled" && entry.service?.value
          ? { serviceId: entry.service.value }
          : {}),
        clientId: entry.client?.value,
        ...(entry.employee?.value ? { employeeId: entry.employee.value } : {}),
        ...(logDate ? { logDate } : {}),
        ...(entry.logType === "Non-Scheduled"
          ? { title: "Non-Scheduled Log" }
          : {}),
      }))

      const response = await axiosbaseurl.post(
        "/task-updates/reportee/timesheets",
        payload
      )

      if (response?.data?.success) {
        swal(
          "",
          `${entries.length} Report${
            entries.length > 1 ? "s" : ""
          } Saved successfully.`,
          "success"
        )
        setEntries([createEmptyEntry()])
        setDescription("")
        if (onSuccess) onSuccess(response.data.data)
      }
    } catch (error) {
      console.log(error)
      const msg =
        error?.response?.data?.message ||
        error.message ||
        "Something went Wrong"

      swal(
        "",
        msg,
        msg.includes("No changes were made !") ? "warning" : "error"
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {showTriggerButton && (
        <button
          onClick={() => {
            setShow(true)
          }}
          className="btn btn-primary btn-sm manual-logs-add-button"
        >
          <i className="mdi mdi-clipboard-edit-outline fs-2"></i>
        </button>
      )}

      <Modal
        size="xl"
        fullscreen
        isOpen={show}
        toggle={() => setShow(!show)}
        centered={true}
      >
        <form onSubmit={handleSubmit} className="modal-content">
          <ModalHeader className="w-100 bg-primary">
            <div className="d-flex align-items-center justify-content-between w-100 px-2">
              <div>
                <h5 className="mb-0 text-white">Add retrospective timesheet</h5>
                <div style={{ fontSize: 12, color: "rgba(255,255,255,.75)" }}>
                  {entries.length} {entries.length > 1 ? "entries" : "entry"} ·{" "}
                  {getDayTotal()} hrs
                </div>
              </div>
              <div className="d-flex align-items-center">
                <LoadingButton loading={loading} btn="light" btnText="Submit" />
                <button
                  type="button"
                  className="btn btn-danger ms-3"
                  onClick={() => setShow(!show)}
                >
                  <i className="fa fa-times me-2"></i> Close
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody style={{ background: "#F3F5F9", padding: "20px 24px" }}>
            {/* fixed context: date */}
            <div
              style={{
                background: "#FFFFFF",
                border: "1px solid #E2E8F0",
                borderRadius: 12,
                padding: "14px 16px",
                marginBottom: 14,
                boxShadow: "1px 2px 10px #cacaca",
              }}
            >
              <div
                className="d-flex flex-wrap align-items-end justify-content-between"
                style={{ gap: 20 }}
              >
                <div>
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#64748B",
                      marginBottom: 6,
                      display: "block",
                    }}
                  >
                    Date <span className="text-danger">*</span> (Last 5 days
                    only)
                  </label>
                  <input
                    type="date"
                    value={logDate}
                    min={minDate}
                    max={maxDate}
                    onChange={e => setLogDate(e.target.value)}
                    className="form-control input-field"
                    style={{ minWidth: 180, maxWidth: 220 }}
                    required
                  />
                </div>
                <div className="text-end">
                  <div style={{ fontSize: 12, color: "#64748B" }}>
                    {entries.length} {entries.length > 1 ? "entries" : "entry"}
                  </div>
                  <div
                    style={{
                      fontSize: 20,
                      fontWeight: 700,
                      color: "#102A43",
                      lineHeight: 1.2,
                    }}
                  >
                    {getDayTotal()}{" "}
                    <span
                      style={{
                        fontSize: 12,
                        fontWeight: 400,
                        color: "#64748B",
                      }}
                    >
                      hrs total
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {entries.map((entry, index) => {
              const total = getEntryTotal(entry)
              return (
                <div
                  key={entry.key}
                  style={{
                    background: "#FFFFFF",
                    border: "1px solid #E2E8F0",
                    borderLeft: "3px solid #0E6E6E",
                    borderRadius: 12,
                    padding: "14px 16px",
                    marginBottom: 12,
                    boxShadow: "1px 2px 10px #cacaca",
                  }}
                >
                  <div
                    className="d-flex justify-content-between align-items-center flex-wrap"
                    style={{ marginBottom: 10, gap: 8 }}
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: 10 }}
                    >
                      <span
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: "#0E6E6E",
                          background: "#E6F4F0",
                          borderRadius: 20,
                          padding: "2px 10px",
                        }}
                      >
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <span
                        style={{
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#102A43",
                        }}
                      >
                        Entry {index + 1}
                      </span>
                      {entry.client?.label && (
                        <span style={{ fontSize: 12, color: "#64748B" }}>
                          {entry.client.label}
                        </span>
                      )}
                    </div>
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: 10 }}
                    >
                      <div
                        style={{
                          background: "#EDF2F7",
                          borderRadius: 8,
                          padding: 2,
                          display: "flex",
                          gap: 2,
                        }}
                      >
                        {logTypeOptions.map(type => {
                          const active = entry.logType === type
                          return (
                            <label
                              key={type}
                              htmlFor={`logtype-${entry.key}-${type}`}
                              className="mb-0 text-nowrap"
                              style={{
                                padding: "5px 12px",
                                borderRadius: 6,
                                fontSize: 11,
                                fontWeight: 600,
                                cursor: "pointer",
                                background: active ? "#0E6E6E" : "transparent",
                                color: active ? "#FFFFFF" : "#334155",
                                border: active
                                  ? "1px solid #0E6E6E"
                                  : "1px solid transparent",
                              }}
                            >
                              <input
                                type="radio"
                                id={`logtype-${entry.key}-${type}`}
                                name={`logtype-${entry.key}`}
                                checked={active}
                                onChange={() => {
                                  updateEntry(entry.key, "logType", type)
                                  if (type === "Scheduled") {
                                    updateEntry(entry.key, "service", null)
                                  } else {
                                    updateEntry(entry.key, "task", null)
                                  }
                                }}
                                style={{
                                  position: "absolute",
                                  opacity: 0,
                                  pointerEvents: "none",
                                }}
                              />{" "}
                              <span>{type}</span>
                            </label>
                          )
                        })}
                      </div>
                      <span
                        style={{
                          fontSize: 13,
                          fontWeight: 700,
                          color: "#102A43",
                          background: "#F1F5F9",
                          borderRadius: 20,
                          padding: "4px 12px",
                        }}
                      >
                        {total} hrs
                      </span>
                      {entries.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => removeEntry(entry.key)}
                        >
                          <i className="fas fa-trash me-1"></i> Remove
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-md-4">
                      <label
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: "#475569",
                          marginBottom: 6,
                          display: "block",
                        }}
                      >
                        Employee <span className="text-danger">*</span>
                      </label>
                      <Select
                        value={entry.employee}
                        onChange={e => updateEntry(entry.key, "employee", e)}
                        options={employeeOptions}
                        styles={customStyles}
                        placeholder="Select Employee..."
                      />
                    </div>
                    <div className="col-md-4">
                      <label
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: "#475569",
                          marginBottom: 6,
                          display: "block",
                        }}
                      >
                        Client <span className="text-danger">*</span>
                      </label>
                      <Select
                        value={entry.client}
                        onChange={e => updateEntry(entry.key, "client", e)}
                        options={clientOptions}
                        styles={customStyles}
                        placeholder="Select client..."
                      />
                    </div>
                    {entry.logType === "Scheduled" ? (
                      <div className="col-md-4">
                        <label
                          style={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#475569",
                            marginBottom: 6,
                            display: "block",
                          }}
                        >
                          Task <span className="text-danger">*</span>
                        </label>
                        <Select
                          value={entry.task}
                          onChange={e => updateEntry(entry.key, "task", e)}
                          options={
                            entry.client?.value
                              ? tasksOptions?.filter(
                                  tsk => tsk.clientId === entry.client?.value
                                )
                              : []
                          }
                          isDisabled={!entry.client}
                          styles={customStyles}
                          placeholder="Select task..."
                        />
                      </div>
                    ) : (
                      <div className="col-md-4">
                        <label
                          style={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#475569",
                            marginBottom: 6,
                            display: "block",
                          }}
                        >
                          Service <span className="text-danger">*</span>
                        </label>
                        <Select
                          value={entry.service}
                          onChange={e => updateEntry(entry.key, "service", e)}
                          options={getFilteredServicesForEntry(entry)}
                          isDisabled={!entry.client}
                          styles={customStyles}
                          placeholder="Select service..."
                        />
                      </div>
                    )}

                    <div className="col-md-3">
                      <label
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: "#475569",
                          marginBottom: 6,
                          display: "block",
                        }}
                      >
                        Start time <span className="text-danger">*</span>
                      </label>
                      <input
                        type="time"
                        value={entry.startTime}
                        onChange={e =>
                          updateEntry(entry.key, "startTime", e.target.value)
                        }
                        className="form-control input-field"
                        required
                      />
                    </div>
                    <div className="col-md-3">
                      <label
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: "#475569",
                          marginBottom: 6,
                          display: "block",
                        }}
                      >
                        End time <span className="text-danger">*</span>
                      </label>
                      <input
                        type="time"
                        value={entry.endTime}
                        onChange={e =>
                          updateEntry(entry.key, "endTime", e.target.value)
                        }
                        className="form-control input-field"
                        required
                      />
                    </div>
                    <div
                      className={
                        entry.logType === "Scheduled" ? "col-md-3" : "col-md-6"
                      }
                    >
                      <label
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: "#475569",
                          marginBottom: 6,
                          display: "block",
                        }}
                      >
                        Work type <span className="text-danger">*</span>
                      </label>
                      <Select
                        value={entry.workType}
                        onChange={e => updateEntry(entry.key, "workType", e)}
                        options={worksTypeOptions}
                        styles={customStyles}
                        placeholder="Select work type..."
                      />
                    </div>
                  </div>
                </div>
              )
            })}

            <button
              type="button"
              onClick={addEntry}
              className="btn w-100"
              style={{
                border: "1.5px dashed #94A3B8",
                borderRadius: 10,
                background: "transparent",
                color: "#0E6E6E",
                fontWeight: 600,
                padding: "10px",
              }}
            >
              <i className="fas fa-plus me-2"></i> Add another entry
            </button>
          </ModalBody>
        </form>
      </Modal>
    </>
  )
}

export default AddReporteesManualLogs
